import EventBus from "@/commonui/utils/eventBus";
import { IRendererActions } from "@/components/conversation-renderer/conversation-renderer-util";
import { ConversationBuilderState } from "@/modules/conversation-builder";
import { Component, Prop, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { Button, Icon, Modal } from "ant-design-vue";
import { fmtMsg, MessageHelper, NotificationType } from "commonui";
import { CommonLocale, ConversationBuilderLocale } from "@/locales/localeid";
import { ConversationBuilderService } from "@/services/conversation-builder";
import { disabledDueToAccessLevel, getRouteAccessLevel, showErrorMessage } from "@/util/func";

@Component({
	components: { Icon, Button }
})
export default class ConversationActions extends Vue {
	@Prop({ default: false }) readonly!: boolean;
	@Prop({ default: () => [] }) extraActions!: IRendererActions[];
	@Prop({ default: false }) showDraftCompleteAction!: boolean;
	public bus = EventBus;
	public format = fmtMsg;
	public conversationLocale = ConversationBuilderLocale;
	public loading = false;

	public conversationStore = getModule(ConversationBuilderState);

	mounted() {
		if (this.isDraftCompleteActionVisible && !this.disabledDueToAccessLevel) {
			this.conversationStore.getConversationCompleteState(
				this.conversationStore.conversationProperties.id as number
			);
		}
	}

	get isDraftCompleteActionVisible() {
		return (
			this.showDraftCompleteAction &&
			this.conversationStore.conversationProperties.id &&
			this.conversationStore.conversationProperties.id > 0 &&
			!this.disabledDueToAccessLevel
		);
	}

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	get disabledDueToAccessLevel() {
		return disabledDueToAccessLevel(this.currentRouteAccessLevel);
	}

	async onCompleteToggle() {
		if (this.conversationStore.isConversationComplete) {
			this.completeToggleOperation();
		} else {
			this.loading = true;
			ConversationBuilderService.getConversationPublishedStatus(
				this.conversationStore.conversationProperties.id as number
			)
				.then((isPublished) => {
					this.loading = false;
					if (!isPublished) {
						Modal.confirm({
							title: fmtMsg(ConversationBuilderLocale.ConversationPublishedWarningTitle),
							content: fmtMsg(ConversationBuilderLocale.ConversationPublishedWarningMessage),
							okText: fmtMsg(CommonLocale.CommonOkButtonText),
							cancelText: fmtMsg(CommonLocale.CommonCancelButtonText),
							onOk: () => {
								this.completeToggleOperation();
							},
							onCancel: () => {}
						});
					} else {
						this.completeToggleOperation();
					}
				})
				.catch(() => {
					this.loading = false;
					MessageHelper.Message(
						NotificationType.Failed,
						fmtMsg(ConversationBuilderLocale.ConversationPublishedStatusErrorMessage)
					);
				});
		}
	}

	private completeToggleOperation() {
		this.loading = true;
		ConversationBuilderService.toggleIsComplete(
			this.conversationStore.conversationProperties.id as number,
			!this.conversationStore.isConversationComplete
		)
			.then(() => {
				this.conversationStore.setIsConversationComplete(!this.conversationStore.isConversationComplete);
				this.loading = false;
			})
			.catch(({ error_code, error_description }) => {
				showErrorMessage(
					{ error_code, error_description },
					fmtMsg(CommonLocale.CommonContentConversationAssociationDraftMessage)
				);
				this.loading = false;
			});
	}
	
	public onDelete() {
	    const selectedNodes = Object.keys(this.conversationStore.selectedNodes);
		if (selectedNodes.length) {
			this.conversationStore.removeNodes(selectedNodes);
		}
	}

	public getClass(action: IRendererActions) {
		const merged = { "cb-action--inactive": action.disabled };

		if (action.customClasses) {
			action.customClasses.forEach((c) => {
				merged[c] = true;
			});
		}
		return merged;
	}
}

export enum ConversationActionType {
	zoomIn,
	zoomOut
}
